module.exports = __webpack_public_path__ + "817468e629e524bb8a08edb68e2b43ff.png";